module.exports = __webpack_public_path__ + "img/logo-1.2f1058a0.png";